require('./categories-edit-container.scss')

module.exports = {
  template: require('./categories-edit-container.pug')()
  controller: require('./categories-edit-container.ctrl')
}
